import { useEffect, useState } from "react";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import { Btn } from "../../../AbstractElements";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import {
  useAddSurveyQuestion,
  useSurveyConfiguration,
  useUpdateSurveyQuestion,
} from "../hook/useSurvey";
import { handleMedia } from "../../edetailing/repository/EdetailingRepository";
import { FaTrash } from "react-icons/fa";

type ProductCardProps = {
  setIsModalOpen?: any;
  isModalOpen?: any;
  toggleModal?: any;
  title?: any;
  checkAddEditStatus?: any;
  setCheckAddEditStatus?: any;
  SurveyID?: number;
  SurveyRowQuestion?: any;
};
const SurveyQuestionsAddAndEditModal: React.FC<ProductCardProps> = ({
  SurveyRowQuestion,
  SurveyID,
  setIsModalOpen,
  isModalOpen,
  title,
  checkAddEditStatus,
  setCheckAddEditStatus,
}) => {
  const {
    data: SurveyQuestionData,
    isLoading: SurveyQuestionLoading,
    isSuccess: SurveyQuestionIsSuccess,
  } = useSurveyConfiguration({ enable: true });

  const { mutate: addSurveyQuestion } = useAddSurveyQuestion();
  const { mutate: UpdateSurveyQuestion } = useUpdateSurveyQuestion();

  const {
    data: surveyConfig,
    isLoading: SurveyConfigIsLoading,
    isSuccess: SurveConfigIsSuccess,
  } = useSurveyConfiguration({ enable: true });

  const [formData, setformData] = useState({
    Survey_Question_Type: "",
    Status: "",
    Is_Requried: "",
    Survey_Question_Options: "",
    Question: "",
    MediaId: "",
  });

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";
  useEffect(() => {
    if (checkAddEditStatus === "Edit") {
      setformData((prev: any) => ({
        ...prev,
        Survey_Question_Type: SurveyRowQuestion.survey_question_type,
        Status: SurveyRowQuestion.status,
        Is_Requried: SurveyRowQuestion.IsRequired ? 1 : 0,
        Question: SurveyRowQuestion.survey_question,
        MediaId: SurveyRowQuestion.MediaId,
        Survey_Question_Options: SurveyRowQuestion.survey_question_options,
      }));
    }
  }, [checkAddEditStatus]);

  const handleInput = (key: string, value: any) => {
    setformData((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleCancilBtn = () => {
    setIsModalOpen(false);
    setCheckAddEditStatus("");
    setformData({
      Survey_Question_Type: "",
      Status: "",
      Is_Requried: "",
      Survey_Question_Options: "",
      Question: "",
      MediaId: "",
    });
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        setformData((prev: any) => ({ ...prev, MediaId: String(mediaId) }));
      } catch (error: any) {
        console.log("Media Upload failed", error);
      }
    }
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (checkAddEditStatus === "Add") {
      const formatedWay_survey_Question =
      String(formData.Survey_Question_Options)?.split(",");

      const ReqBody = {
        Surveyquestype: formData.Survey_Question_Type,
        Surveyquestionopt: formatedWay_survey_Question,
        Question: formData.Question,
        Status: formData.Status,
        IsRequired: formData.Is_Requried === "1" ? "Yes" : "No",
        MediaId: Number(formData.MediaId),
      };
      addSurveyQuestion({ ReqBody: ReqBody, surveyId: SurveyID ?? null });
      handleCancilBtn();
    }
    if (checkAddEditStatus === "Edit") {
      const formatedWay_survey_Question =
       String(formData.Survey_Question_Options)?.split(",");
      const ReqBody = {
        Surveyquestype: formData.Survey_Question_Type,
        Surveyquestionopt: formatedWay_survey_Question,
        Question: formData.Question,
        Status: formData.Status,
        IsRequired: formData.Is_Requried === "1" ? "Yes" : "No",
        MediaId: Number(formData.MediaId),
      };
      UpdateSurveyQuestion({
        ReqBody: ReqBody,
        SurveyQuestionID: SurveyRowQuestion.Surveyquesid ?? null,
      });
      handleCancilBtn();
    }
  };

  return (
    <RouteModal
      isOpen={isModalOpen}
      toggle={() => {
        setIsModalOpen(!isModalOpen);
        setformData({
          Survey_Question_Type: "",
          Status: "",
          Is_Requried: "",
          Survey_Question_Options: "",
          Question: "",
          MediaId: "",
        });
      }}
      title={title}
      // title="Add MTP"
      size="lg"
      content={
        <form onSubmit={handleSubmit}>
          <div className="row mb-0">
            <div className="d-flex justify-content-start gap-2">
              <ReusableDropdown
                options={
                  (!SurveyQuestionLoading &&
                    SurveyQuestionIsSuccess &&
                    SurveyQuestionData?.formatedData_SurveyQuesTypes) ||
                  []
                }
                value={formData.Survey_Question_Type}
                onChange={(value: any) =>
                  handleInput("Survey_Question_Type", value)
                }
                DropdownHeading="Survey Question Type*"
              />
              <ReusableDropdown
                options={
                  (!SurveyConfigIsLoading &&
                    SurveConfigIsSuccess &&
                    surveyConfig?.formatedData_SurveyStatus) ||
                  []
                }
                value={formData.Status}
                onChange={(value: any) => handleInput("Status", value)}
                DropdownHeading="Status*"
              />
              <ReusableDropdown
                options={
                  (!SurveyConfigIsLoading &&
                    SurveConfigIsSuccess &&
                    surveyConfig?.formatedData_SurveyRequired) ||
                  []
                }
                value={formData.Is_Requried}
                onChange={(value: any) => handleInput("Is_Requried", value)}
                DropdownHeading="Is Requried*"
              />
            </div>
            <div className="d-flex justify-content-start gap-2">
              <CustomInput
                placeholder="Write Questions"
                disabled={
                  !["Dropdown", "Radio", "Checkbox"].includes(
                    formData.Survey_Question_Type
                  )
                }

                onChange={(e: any) =>
                  handleInput("Survey_Question_Options", e.target.value)
                }
                value={formData.Survey_Question_Options}
                label="Survey Question Options"
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  padding: "10px",
                  fontSize: "14px",
                  backgroundColor: !["Dropdown", "Radio", "Checkbox"].includes(formData.Survey_Question_Type) ? "#d0d0d0": undefined
                }}
              />
            </div>
            <div className="d-flex justify-content-start gap-2">
              <CustomInput
                placeholder="Question"
                disabled={false}
                onChange={(e: any) => handleInput("Question", e.target.value)}
                value={formData.Question}
                required={true}
                label="Question*"
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  padding: "10px",
                  fontSize: "14px",
                }}
              />
            </div>

            <div style={{ height: 10 }} />
            
            <label className="mt-2" style={{ fontWeight: "500" }}>
              Upload media
            </label>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <input
                accept="image/*"
               id="mediaUpload"
                type="file"
                className="form-control"
                onChange={(e: any) => handleFileChange(e)}
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "250px",
                  color: "red",
                }}
              />

              {formData.MediaId && (
                
              <div style={{
                 position: "relative",
                marginTop: "10px",
                width: "fit-content",   
              }}>
                <img
                  src={`${BASE_URL}${formData.MediaId}`}
                  style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  }}
                />

                  <span onClick={() => {
                     setformData((prevState: any) => ({
                        ...prevState,
                        MediaId: "",
                        mediaFile: null,
                      }));
    
                      // ✅ Clear input value
                      const fileInput = document.getElementById(
                        "mediaUpload"
                      ) as HTMLInputElement;
                      if (fileInput) fileInput.value = "";
                    }}
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "50%",
                      padding: "2px 6px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                 <FaTrash size={14} color="red" />
                </span>
               </div>

              ) }
            </div>

            {/* <input
              accept="image/*"
              type="file"
              className="form-control"
              onChange={(e: any) => handleFileChange(e)}
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                padding: "13px",
                fontSize: "14px",
                width: "250px",
                color: "red",
                marginLeft: 10,
                backgroundColor:'yellow',
              }}
            />

            <img
              src={
                formData.MediaId
                  ? `${BASE_URL}${formData.MediaId}`
                  : undefined
              }
              style={{
                backgroundColor:'red',
                maxWidth: "100px",
                // height: "100px",
                // borderRadius: "8px",
                marginTop: "8px",
              }}
            /> */}

            <div style={{ height: 20 }} />
            <div className="d-flex justify-content-start gap-2">
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
              >
                {checkAddEditStatus === "Add" ? "Submit" : "Update"}
              </Btn>
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={() => handleCancilBtn()}
              >
                Cancel
              </Btn>
            </div>
          </div>
        </form>
      }
    />
  );
};

export default SurveyQuestionsAddAndEditModal;
